module.exports = __webpack_public_path__ + "img/3.8ae16dd9.jpg";